import styled from "@emotion/styled";

export const StyledActionCell = styled("div")`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
`;
